import { gql } from '@apollo/client';

export const PEOPLE_PROFILE_ORGANISATION = gql`
  fragment peopleProfileOrganisation on PeopleProfileOrganisation {
    id
    designation
    primary
    organisation {
      id
      institution {
        id
        name
      }
      funder {
        id
        name
      }
      serviceProvider {
        id
        name
      }
    }
  }
`;
